import { Component, Input, OnInit } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { ProductService, ProductStore } from 'src/app/shared-lib/domains/product';

@Component({
  selector: 'app-products-in-pack',
  templateUrl: './products-in-pack.component.html',
  styleUrls: ['./products-in-pack.component.scss'],
  standalone: false
})
export class ProductsInPackComponent implements OnInit {

  @Input() packProducts: Array<any>;

  products: Array<ProductStore> = [];

  constructor(
    public productService: ProductService,
  ) { }

  ngOnInit() {
    // console.log('PackProducts received', this.packProducts);

    const observables = this.packProducts.map(product => {
      if (product.variationId) {
        return this.productService.getProductWithVariants$(product.productId).pipe(
          map(prod => {
            const variationId = product.variationId;
            if (!prod) return null;

            const variants = prod.variants as any[];
            let variation = variationId ? variants.find(variant => variant?.id === variationId) : variants.length ? variants[0] : null;

            if (variation) {
              variation.title = prod.title;
            }

            return variation;
          })
        );
      } else {
        return this.productService.getProduct$(product.productId);
      }
    });

    combineLatest(observables).subscribe(results => {
      this.products = results.filter(result => result !== null) as ProductStore[];
    });

  }

  getQty(product) {
    return this.packProducts.find(prod => (prod.variationId ?? prod.productId) === product.id).qty;
  }

}

